import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";
import "./hm-theme.css";

const UpdatePackagePriceModal = ({ isOpen, onRequestClose, packageId }) => {
  const navigate = useNavigate();
  const [price, setPrice] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!price || parseFloat(price) <= 0) {
      toast.error("Please enter a valid price.");
      return;
    }

    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

    try {
      const today = new Date();
      const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

      const requestBody = {
        packageId: packageId,
        price: parseFloat(price),
        date: formattedDate
      };

      await axios.post(`/api/labPackagePrice/create`, requestBody, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      toast.success("Package price updated successfully");
      handleClose();
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  const handleClose = () => {
    setPrice("");
    onRequestClose();
  };

  return (
    <Modal show={isOpen} onHide={handleClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">payments</i>
          Update Package Price
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="price" className="form-label small fw-semibold">
              New Price (₹) <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="price"
              type="number"
              step="0.01"
              min="0"
              placeholder="Enter new package price..."
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              required
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>price_change</i>
              Update Price
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default UpdatePackagePriceModal;
